import React from 'react';
import { SelectProps } from 'antd';
import { Icon, ICONS } from '@thinknet-gmbh/platform-common-ui';

import { StyledAutocompleteSelect } from './autocomplete-select..styles';

const AutocompleteSelect = (props: SelectProps<any>) => {
  return (
    <StyledAutocompleteSelect
      showSearch
      filterOption={(input, option) =>
        ((option?.label ?? '') as string)?.toLowerCase().includes(input.toLowerCase())
      }
      suffixIcon={<Icon icon={ICONS.search} size={20} />}
      getPopupContainer={trigger => trigger.parentNode}
      {...props}
    />
  );
};

export default AutocompleteSelect;
